var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.53 6.53a.75.75 0 00-1.06-1.06L12 10.94 6.53 5.47a.75.75 0 00-1.06 1.06L10.94 12l-5.47 5.47a.75.75 0 101.06 1.06L12 13.06l5.47 5.47a.75.75 0 101.06-1.06L13.06 12l5.47-5.47z",
    fill: "currentColor"
  })));
}

export default SvgClose;